<app-header></app-header>

<mat-card class="content-card" style="text-align: center">

  <img class="logo" src="assets/img/kingplus_topleft.png"  alt="kingplus logo"/>

  <div style="text-align: center">

    <div *ngIf="isIOS">
      {{ 'APP.REDIRECTING_TO_APP_STORE' | translate }}...
    </div>

    <div *ngIf="isAndroid">
      {{ 'APP.REDIRECTING_TO_PLAY_STORE' | translate }}...
    </div>


    <div *ngIf="showQRCode">
        <h2>{{ 'APP.SCAN_CODE_BELOW' | translate }}</h2>
      <qr-code [value]="qrCodeUrl" [size]="256" [level]="'M'"></qr-code>
    </div>

    <br />
    <h2>{{ 'APP.DOWNLOAD_KING_PLUS' | translate }}</h2>

  </div>


</mat-card>
